<!-- 空运-数据追踪 -->
<template>
  <div class="app-main-content">
    <div class="section tab-data-tracking">
      <div style="min-width: fit-content">
        <div class=" basic-info">
          <div class="basic-info-left">
            <div style="display: flex">
              <p class="basic-info-mbl">{{ $t('CargoMsg.Cargo_MblNo') }}</p>
              <el-input v-model="job.mbl" disabled style="width: 200px" />
            </div>
            <div class="basic-info-port" style="display: table;">
              <div style="width: 100%; display: flex;">
                <port-item
                  no="portOfLoading"
                  icon="/static/data_tracking/u7.png"
                  :title="$t('Payment.portOfLoading')"
                  :value="basicInfo.loadingPort"
                />
                <port-item
                  no="portOfDestination"
                  icon="/static/data_tracking/u8.png"
                  :title="$t('Payment.portOfDestination')"
                  :value="basicInfo.destinationPort"
                />
                <port-item
                  no="ContainerAmount"
                  icon="/static/data_tracking/u22.png"
                  :title="$t('CargoMsg.Cargo_Flight')"
                  :value="String(job.voyageFlight)"
                />
              </div>
              <el-row style="display: flex;" :gutter="10">
                <el-col :span="8">
                  <port-item
                    no="portOfLoading"
                    :title="$t('SeaExport.ActualQuantity')"
                    :value="quantityActual"
                  />
                </el-col>
                <el-col :span="8">
                  <port-item
                    no="portOfDestination"
                    :title="$t('CargoMsg.Cargo_ActualWeight')"
                    :value="weightActual"
                  />
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
        <div style="display:flex;">
          <div class="instructions">
            <span style="color:#1F75D5;"> : {{ $t('CargoMsg.Cargo_EnterManually') }}</span>
            <span style="color:#efb336;"> : {{ $t('CargoMsg.Cargo_DataService') }}</span>
            <span style="color:#CCCCCC;"> : {{ $t('SeaExport.promptNoData') }}</span>
          </div>
        </div>
        <div class="step-info">
          <el-steps class="steps">
            <el-step
              v-for="step in stepList"
              :key="step.type"
              :title="step.name"
              style="position:relative;"
              :status="step.manualIsFinish ? 'process' : step.isFinish ? 'finish' : 'wait'"
            >
              <template slot="icon">
                <img :src="`/static/data_tracking/${step.manualIsFinish ? step.manualIcon : step.icon}`">
              </template>
              <template slot="description">
                <span v-show="step.showTime">{{ step.time }}</span>
                <div style="clear: both" />
              </template>
            </el-step>
          </el-steps>
          <span style="float: right;font-size: 20px;font-weight: lighter;">{{ $t('SeaExport.TopLocalTime') }}</span>
          <div v-show="airFlightDetails.show">
            <span style="font-size: 16px;font-weight: bold;" class="basic-info-mbl">{{ $t('AirExport.FlightInformation') }}</span>
            <el-table
              class="air-flight-details"
              :data="airFlightDetails.rowData"
              :span-method="mergeMethod"
              height="100%"
              border
              style="width: 885px"
            >
              <el-table-column
                prop="airlineCode"
                align="center"
                :label="$t('SeaExport.AirlineCompany')"
                width="100"
              >
                <template slot-scope="scope">
                  <span style="display: block;text-align: center;">{{ getAirlineName(scope.row) }}</span>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                :label="$t('AirExport.StartingStation')"
                width="100"
              >
                <template slot-scope="scope">
                  <span>{{ getStationName(scope.row.originIata) }}</span>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                :label="$t('AirExport.DestinationStation')"
                width="100"
              >
                <template slot-scope="scope">
                  <span>{{ getStationName(scope.row.destinationIata) }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="flightNo"
                align="center"
                :label="$t('AirExport.FlightNumber')"
                width="100"
              />
              <el-table-column
                align="center"
                :label="$t('AirExport.DepartureTime')"
                width="180"
              >
                <template slot-scope="scope">
                  <span style="display: block;text-align: center;">{{ scope.row.etd ? scope.row.etd + ' (ETD)' : '-' }}</span>
                  <span style="display: block;text-align: center;">{{ scope.row.atd ? scope.row.atd + ' (ATD)' : '-' }}</span>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                :label="$t('AirExport.ArrivalTime')"
                width="180"
              >
                <template slot-scope="scope">
                  <span style="display: block;text-align: center;">{{ scope.row.eta ? scope.row.eta + ' (ETA)' : '-' }}</span>
                  <span style="display: block;text-align: center;">{{ scope.row.ata ? scope.row.ata + ' (ATA)' : '-' }}</span>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="pieces"
                :label="$t('AirExport.Pieces')"
                width="60"
              />
              <el-table-column
                align="center"
                prop="weight"
                :label="$t('AirExport.Weight')"
                width="60"
              />
            </el-table>
          </div>
          <br>
          <div v-show="airTrackingDetails.show">
            <span style="font-size: 16px;font-weight: bold;" class="basic-info-mbl">{{ $t('AirExport.TrackingDetails') }}</span>
            <el-table
              class="air-flight-details"
              :data="airTrackingDetails.rowData"
              height="100%"
              :span-method="mergeMethod2"
              border
              style="width: 90%;"
            >
              <el-table-column
                align="center"
                :label="$t('AirExport.Airport')"
                style="width: 15%"
              >
                <template slot-scope="scope">
                  <span>{{ getStationName(scope.row.station) }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="date"
                align="center"
                :label="$t('AirExport.Time')"
                style="width: 15%"
              />
              <el-table-column
                align="center"
                :label="$t('AirExport.Status')"
                style="width: 15%"
              >
                <template slot-scope="scope">
                  <span>{{ getStatus(scope.row) }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="flightNo"
                align="center"
                :label="$t('AirExport.FlightNumber')"
                style="width: 15%"
              />
              <el-table-column
                align="center"
                prop="pieces"
                :label="$t('AirExport.Pieces')"
                style="width: 15%"
              />
              <el-table-column
                align="center"
                prop="weight"
                :label="$t('AirExport.Weight')"
                style="width: 15%"
              />
            </el-table>
          </div>
        </div>
      </div>
      <div class="hideWire">
        <el-dialog
          v-dialogDrag
          :visible.sync="dialogVisible"
          :modal="false"
          :close-on-press-escape="false"
          :close-on-click-modal="false"
          width="350px"
        >
          <div class="text">
            <i class="el-icon-warning" />
            <div style="font-size:14px;">
              {{ $t('SeaExport.DetectionOfBasicTab') }}<span class="red">{{ containersText.toString().replaceAll('、') }}</span>{{ $t('SeaExport.InconsistentThePortAreaReturn') }}<span class="red">{{
                containersText.toString().replaceAll('、') }}</span>{{ $t('SeaExport.PleaseTheOperationIsCorrect') }}<span class="red">{{
                containersText.toString().replaceAll('、') }}</span>{{ $t('Message.IsItCorrect') }}<br>{{ $t('SeaExport.YouBoxAndCargoTab') }}<span
                class="see"
                @click="toPacking"
              >{{ $t('SeaExport.GoCheck') }}</span>
            </div>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cacheName, cache } from '@/utils/cacheManager'
import StrUtils from '@/utils/StrUtils'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import moment from 'moment'
import DateUtils from '@/utils/dateUtils'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { sortByMultiField } from '@/utils'
import PortItem from '@/views/cargo/v0/AirExport/components/AeBooking/tabs/TabDataTracking/components/PortItem'
import { Job } from '@/class/model/booking/Job'
import { getProperties } from '@/api/user'
import { airDataTracking, getAirTrackingDetails, getAirFlightDetails } from '@/api/seaExport/dataTracking'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import * as subscribePortPushRuleApi from '@/api/sysManage/subscribePortPushRule'

export default {
  name: 'TabAirDataTracking',
  components: { PortItem, cargoAdvanceSelect },
  props: {
    context: { type: Object, required: true },
    job: { type: Object, required: true },
    action: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      containers: {
        eqSize: '',
        eqType: '',
        num: ''
      },
      containersText: [],
      dialogVisible: false,
      pushDataTime: {
        fileCutoff: '',
        terminalOpendate: '',
        actualBerthPlanDate: '',
        actualUnBerthPlanDate: '',
        portDischargeTime: '',
        actualPickUpTime: '',
        destPortReturnTime: '',
        berthPlanDate: '',
        unBerthPlanDate: ''
      },
      queryDataPushLog: {},
      mblNo: 'all',
      blNoArray: [],
      truckingInfo: {},
      loading: false,
      containerStepActive: null,
      isViewContainerInformation: false, // 是否显示箱货信息  参数值：0：不显示  参数值：1：显示
      basicInfo: {
        loadingPort: '',
        destinationPort: '',
        totalContainerNum: '0',
        etd: '',
        filecutoff: '',
        actualBerthPlanDate: '',
        actualUnberthPlan: '',
        mbl: 'B/L'
      },
      quantityActual: '',
      weightActual: '',
      stepList: [
        {
          type: 'bookingDate',
          name: this.$t('SeaExport.Booking'),
          icon: 'air-01a.png',
          manualIcon: 'air-01.png',
          showTime: true,
          time: '',
          isFinish: false
        }, {
          type: 'actualEntryTime',
          name: this.$t('SeaExport.EnterTheCabin'),
          icon: 'air-02a.png',
          manualIcon: 'air-02.png',
          manualTime: this.job.actualEntryTime, // 实际进场时间
          pushTime: '',
          showTime: true,
          time: '',
          isFinish: false,
          manualIsFinish: false
        }, {
          type: 'actualLoadingTime',
          name: this.$t('SeaExport.AllocateVehiclesToTransportSth'),
          icon: 'air-03a.png',
          manualIcon: 'air-03.png',
          manualTime: this.job.actualLoadingTime, // 实际配载时间
          pushTime: '',
          showTime: true,
          time: '',
          isFinish: false,
          manualIsFinish: false
        }, {
          type: 'actualDepartureTime',
          name: this.$t('queryJob.takeOff'), // 实际起飞时间
          icon: 'air-04a.png',
          manualIcon: 'air-04.png',
          showTime: true,
          time: '',
          isFinish: false
        }, {
          type: 'actualArrivalTime',
          name: this.$t('SeaExport.Arrived'), // 实际抵达时间
          icon: 'air-05a.png',
          manualIcon: 'air-05.png',
          showTime: true,
          time: '',
          isFinish: false
        }, {
          type: 'actualReceivingTime',
          name: this.$t('SeaExport.Acquire'), // 实际收单时间
          icon: 'air-06a.png',
          manualIcon: 'air-06.png',
          showTime: true,
          time: '',
          isFinish: false
        },
        {
          type: 'actualUnloadingTime',
          name: this.$t('CargoMsg.Cargo_Unloading'), // 实际卸货时间
          icon: 'air-07a.png',
          manualIcon: 'air-07.png',
          manualTime: this.job.actualUnloadingTime,
          showTime: true,
          time: '',
          isFinish: false,
          manualIsFinish: false
        }, {
          type: 'actualArrivalNotificationTime',
          name: this.$t('CargoMsg.Cargo_ArrivalNotice'), // 实际到货通知时间
          icon: 'air-08a.png',
          manualIcon: 'air-08.png',
          manualTime: this.job.actualArrivalNotificationTime,
          showTime: true,
          time: '',
          isFinish: false
        }, {
          type: 'actualPickupTime',
          name: this.$t('CargoMsg.Cargo_PickUp'), // 实际提货时间
          icon: 'air-09a.png',
          manualIcon: 'air-09.png',
          manualTime: this.job.actualPickupTime,
          showTime: true,
          time: '',
          isFinish: false,
          manualIsFinish: false
        }
      ],
      manualTimeList: {},
      curContainer: '',
      containerMap: {}, // 箱号：箱信息
      manualList: {},
      freightowerKey: '',
      freightowerClientid: '',
      containerInfo: {},
      containerList: [],
      allContainerList: [],
      blContainersMap: {}, // 提单号对应的箱子信息
      truckingList: [], // 记录所有车牌
      airFlightDetails: {
        rowData: [],
        show: false
      },
      airTrackingDetails: {
        rowData: [],
        show: false
      },
      airPortDataConfigAll: []
    }
  },
  watch: {
    mblNo(val, oldVal) {
      if (val !== oldVal) {
        this.loadData(val)
      }
    },
    'airTrackingDetails.rowData': function(value) {
      if (this.airTrackingDetails.rowData.length > 0) {
        this.airTrackingDetails.show = true
      } else {
        this.airTrackingDetails.show = false
      }
    },
    'airFlightDetails.rowData': function(value) {
      if (this.airFlightDetails.rowData.length > 0) {
        this.airFlightDetails.show = true
      } else {
        this.airFlightDetails.show = false
      }
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.loadConfigData()
    this.initByRoute()
    subscribePortPushRuleApi.getAirPortDataConfigAll().then(res => {
      this.airPortDataConfigAll = res.data
    })
  },
  methods: {
    toPacking() {
      this.dialogVisible = false
      this.$emit('toPacking')
    },
    toTime(item, time, type) {
      if (item.targetValue && item.targetValue.slice(-2) === '.0') {
        item.targetValue = item.targetValue.substring(0, item.targetValue.length - 2)
      }
      if (item.targetValue) {
        item.targetValue = item.targetValue.replaceAll('/', '-')
      }
      if (!time[type]) {
        time[type] = item.targetValue
      }
    },
    // 数据推送日志
    async toQueryDataPushLog() {
      const loading = getLoading4Cxt(this)
      try {
        await new Job(this.job).loadPushHistoryLogs()
      } finally {
        loading.close()
      }
      const dataArr = []
      const item = this.job.pushHistoryLogs
      if (item) {
        for (const k in item) {
          dataArr.push({ 'time': k, 'logs': item[k], 'isEas': false })
        }
      }
      if (dataArr && dataArr.length > 0) {
        // 排序 按时间降序
        // 确保切换后重置了时间，避免使用上次时间进行对比
        const pushTime = {
          bookingDate: '',
          actualEntryTime: '',
          actualLoadingTime: '',
          actualDepartureTime: '',
          actualArrivalTime: '',
          actualReceivingTime: '',
          actualUnloadingTime: '',
          actualArrivalNotificationTime: '',
          actualPickupTime: ''
        }
        sortByMultiField(dataArr, ['time'], true)
        this.queryDataPushLog = dataArr
        this.queryDataPushLog.forEach((item) => {
          // 每个logs中只取第一个值
          (item.logs).forEach((i) => {
            switch (i.fieldName) {
              case '订舱日期':
                this.toTime(i, pushTime, 'bookingDate')
                break
              case '实际进场时间':
                this.toTime(i, pushTime, 'actualEntryTime')
                break
              case '实际配载时间':
                this.toTime(i, pushTime, 'actualLoadingTime')
                break
              case '实际起飞时间':
                this.toTime(i, pushTime, 'actualDepartureTime')
                break
              case '实际抵达时间':
                this.toTime(i, pushTime, 'actualArrivalTime')
                break
              case '实际收单时间':
                this.toTime(i, pushTime, 'actualReceivingTime')
                break
              case '实际卸货时间':
                this.toTime(i, pushTime, 'actualUnloadingTime')
                break
              case '实际到货通知时间':
                this.toTime(i, pushTime, 'actualArrivalNotificationTime')
                break
              case '实际提货时间':
                this.toTime(i, pushTime, 'actualPickupTime')
                break
            }
          })
        })
        this.pushDataTime = { ...pushTime }
      }
    },
    initByRoute() {
      const { mbl, plateNumber } = this.$route.query
      if (mbl) {
        const mblNoArray = mbl.split(',')
        if (mblNoArray.length > 0) {
          // this.mblNo = mblNoArray[0]
          for (const soNo of mblNoArray) {
            if (soNo) {
              const index = this.blNoArray.findIndex(p => p.value === soNo)
              if (index < 0) {
                this.blNoArray.push({ 'value': soNo, 'code': soNo })
              }
            }
          }
        }
        this.truckingInfo = { plateNumber }
      }
    },
    async onShow(row, isRefresh) {
      this.dialogVisible = false
      if (this.job.uuid) {
        await this.toQueryDataPushLog()
      }
      this.mblNo = 'all'
      console.log('this.pushDataTime', this.pushDataTime)
      this.stepList.map((item) => {
        switch (item.type) {
          case 'bookingDate':
            item.manualTime = row.bookingDate
            item.pushTime = this.pushDataTime.bookingDate
            break
          case 'actualEntryTime':
            item.manualTime = row.actualEntryTime
            item.pushTime = this.pushDataTime.actualEntryTime
            break
          case 'actualLoadingTime':
            item.manualTime = row.actualLoadingTime
            item.pushTime = this.pushDataTime.actualLoadingTime
            break
          case 'actualDepartureTime':
            item.manualTime = row.actualDepartureTime
            item.pushTime = this.pushDataTime.actualDepartureTime
            break
          case 'actualArrivalTime':
            item.manualTime = row.actualArrivalTime
            item.pushTime = this.pushDataTime.actualArrivalTime
            break
          case 'actualReceivingTime':
            item.manualTime = row.actualReceivingTime
            item.pushTime = this.pushDataTime.actualReceivingTime
            break
          case 'actualUnloadingTime':
            item.manualTime = row.actualUnloadingTime
            item.pushTime = this.pushDataTime.actualUnloadingTime
            break
          case 'actualArrivalNotificationTime':
            item.manualTime = row.actualArrivalNotificationTime
            item.pushTime = this.pushDataTime.actualArrivalNotificationTime
            break
          case 'actualPickupTime':
            item.manualTime = row.actualPickupTime
            item.pushTime = this.pushDataTime.actualPickupTime
            break
        }
      })
      await this.loadPortData()
      this.basicInfo.destinationPort = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', this.job.destinationPortCode, 'englishName')
      this.basicInfo.loadingPort = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', this.job.loadingPortCode, 'englishName')
      this.loadData(this.mblNo)
      // this.mblNo = row.mbl
      this.truckingInfo = row.trucking[0]
      this.truckingList = []
      if (row.trucking && row.trucking.length > 0) {
        row.trucking.forEach(eve => {
          if (eve.plateNumber) {
            this.truckingList.push(eve)
          }
        })
      }
      this.loadSoNo(row)
      if (row.mbl) {
        this.getAirFlightDetails_a(row.mbl)
        this.getAirTrackingDetails_a(row.mbl)
      }
    },
    loadSoNo(job) {
      const blNoArray = []
      // blNoArray.push({ 'value': 'all', 'code': this.$t('constant.all') })
      this.addSoNoByJob(job, blNoArray)
      // 如果是主票、则同时加载全部小票mbl+soNo
      if (job.masterFlag) {
        // 获取小票信息
        const slaves = job.lclSlaves
        if (slaves && slaves.length > 0) {
          for (const slave of slaves) {
            this.addSoNoByJob(slave, blNoArray)
          }
        }
      }
      this.blNoArray = blNoArray
    },
    addSoNoByJob(job, blNoArray) {
      if (job.mbl) {
        const index = blNoArray.findIndex(p => p.value === job.mbl)
        if (index < 0) {
          blNoArray.push({ 'value': job.mbl, 'code': job.mbl })
        }
      }
    },
    async loadPortData() {
      this.stepList.forEach(item => {
        this.manualOrThirdParty(item)
        item.isFinish = item.time
      })
      await airDataTracking({ jobUuid: this.job.uuid, tenantId: this.job.tenantId }).then(res => {
        const result = res.data
        this.quantityActual = result ? result.quantityActual ? result.quantityActual.toString() : '' : ''
        this.weightActual = result ? result.weightActual ? result.weightActual.toString() : '' : ''
      })
    },
    /**
     1、页签数据无值。 灰色(不考虑港区数据)
     2、港区数据无值、页签数据有值。蓝色
     3、港区数据有值、页签数据有值。 值一致时，橙色、值不一致时，取页签数据、蓝色。
     * @param item
     * @param step
     */
    manualOrThirdParty(item) {
      if (!item.manualTime) {
        item.time = ''
        item.manualIsFinish = false
        return
      }
      const manualTime = new Date(item.manualTime).valueOf()
      item.time = DateUtils.customFormat(manualTime, DateUtils.STANDARD_MINUTE_TIME)
      // 数据追踪有，推送日志没有
      if (item.manualTime && !item.pushTime) {
        item.manualIsFinish = true
        return
      }
      // 都有
      if (item.manualTime && item.pushTime) {
        const manualTime = new Date(item.manualTime).valueOf()
        const pushTime = new Date(item.pushTime).valueOf()
        // 时间一致，取数据服务，橙色
        if (manualTime === pushTime) {
          item.manualIsFinish = false
        } else {
          // 不一致，取数据追踪，蓝色
          item.manualIsFinish = true
        }
      }
    },
    loadData(val) {
      this.containerList = val === 'all' ? this.allContainerList : (this.blContainersMap.hasOwnProperty(val) ? this.blContainersMap[val] : [])
      if (val !== 'all' && (!this.containerList || this.containerList.length === 0)) {
        this.$message.warning(this.$t('SeaExport.DataTrackingBlHasNotContainer', [val]))
      }
      if (!this.containerList || this.containerList.length === 0) {
        this.containerInfo = {}
        this.curContainer = ''
        return
      }
    },
    // 加载配置项
    loadConfigData() {
      this.isViewContainerInformation = Number(cache.config.get('isViewContainerInformation')) === 1
    },
    goAnchor() {
      this.$refs.refName.scrollIntoView()
    },
    getAirTrackingDetails_a(mbl) {
      getAirTrackingDetails({ mbl: mbl, jobUuid: this.job.uuid }).then(res => {
        this.airTrackingDetails.rowData = res.data
        if (this.airTrackingDetails.rowData.length > 0) {
          this.airTrackingDetails.show = true
        }
      })
    },
    getAirFlightDetails_a(mbl) {
      getAirFlightDetails({ mbl: mbl, jobUuid: this.job.uuid }).then(res => {
        this.airFlightDetails.rowData = res.data
        if (this.airFlightDetails.rowData.length > 0) {
          this.airFlightDetails.show = true
        }
      })
    },
    getStatus(row) {
      switch (row.status) {
        case 'BKD':
          return this.$t('AirExport.BKD')
        case 'RCS':
          return this.$t('AirExport.RCS')
        case 'MAN':
          return this.$t('AirExport.MAN')
        case 'DEP':
          return this.$t('AirExport.DEP')
        case 'ARR':
          return this.$t('AirExport.ARR')
        case 'AWD':
          return this.$t('AirExport.AWD')
        case 'RCF':
          return this.$t('AirExport.RCF')
        case 'NFD':
          return this.$t('AirExport.NFD')
        case 'DLV':
          return this.$t('AirExport.DLV')
        case 'TAR':
          return this.$t('AirExport.TAR')
        case 'TDE':
          return this.$t('AirExport.TDE')
        case 'TRF':
          return this.$t('AirExport.TRF')
        case 'RWB':
          return this.$t('AirExport.RWB')
        case 'CUS':
          return this.$t('AirExport.CUS')
        default :
          return this.$t('AirExport.Unknown')
      }
    },
    getStationName(station) {
      if (!station) {
        return ''
      }
      const allCompany = getCacheListByKey(basicCacheKeys.basic_data_Airport)
      for (const company of allCompany) {
        if (company.code === station) {
          if (company.englishName) {
            return company.englishName.toUpperCase()
          }
        }
      }
      return station.toUpperCase()
    },
    getAirlineName(row) {
      if (this.airPortDataConfigAll) {
        for (const item of this.airPortDataConfigAll) {
          if (item.iataCode === row.airlineCode) {
            return item.airName
          }
        }
      }
      return row.airlineCode
    },
    // row: 当前行 column: 当前列 rowIndex: 当前行索引 columnIndex: 当前列索引
    mergeMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex <= 2) {
        // 只对 type 列进行处理
        let rowName = ''
        if (columnIndex === 0) {
          rowName = 'airlineCode'
        } else if (columnIndex === 1) {
          rowName = 'originIata'
        } else if (columnIndex === 2) {
          rowName = 'destinationIata'
        }
        const rowspan = this.getRowspan(row, rowIndex, rowName, this.airFlightDetails)
        if (rowspan >= 1) {
          return {
            rowspan,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    mergeMethod2({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const rowspan = this.getRowspan(row, rowIndex, 'station', this.airTrackingDetails)
        if (rowspan >= 1) {
          return {
            rowspan,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    getRowspan(row, rowIndex, rowName, data) {
      const currentFactorMainNumber = this.getStationName(row[rowName])
      let rowspan = 1 // 默认rowspan为1，也就是每个单元格只占一行
      // 如果当前行不是第一行，则先查看前一行，如果前一行的值（同列单元格）与当前行（同列单元格）相同，则将当前单元格与前一行合并（当前单元格占0行，rowspan=0）
      if (rowIndex > 0) {
        const previousRow = data.rowData[rowIndex - 1]
        const previousFactorMainNumber = this.getStationName(previousRow[rowName])
        if (currentFactorMainNumber === previousFactorMainNumber) {
          return 0
        }
      }
      // 然后向查看，如果后面行（同列单元格）的值与当前行（同列单元格）相同，则每找到一行rowspan加1，直到找到与当前行（同列单元格）的值不同的行为止。（也就是说只能合并连续的行）
      for (let i = rowIndex + 1; i < data.rowData.length; i++) {
        const nextRow = data.rowData[i]
        const nextFactorMainNumber = this.getStationName(nextRow[rowName])
        if (currentFactorMainNumber === nextFactorMainNumber) {
          rowspan++
        } else {
          break
        }
      }
      return rowspan
    }
  }
}
</script>

<style lang="scss" scoped>
.tab-data-tracking {
  .instructions span {
    position: relative;
    margin-right: 10px;
  }

  .instructions span::before {
    content: "";
    position: absolute;
    right: 58px;
    top: 50%;
    transform: translateY(-50%);
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background-color: currentColor;
  }
  .el-dialog__wrapper {
    pointer-events: none;
  }

  .el-dialog {
    pointer-events: auto;
  }

  .basic-info {
    display: flex;
    border-bottom: 1px solid #DCDFE6;
    min-width: fit-content;
    padding-bottom: 15px;
    margin: 10px 15px;

    &-left {
      display: flex;
      flex-direction: column;
    }

    &-right {
      flex: 1;
    }

    &-mbl {
      font-size: 22px;
      font-weight: 400;
      margin: 0;
    }

    &-port {
      flex: 1;
      display: flex;
      margin-top: 20px;
    }

    &-time {
      min-width: 200px;
      margin-left: 100px;

      span {
        margin: 0;
        text-align: right;
      }
    }

    .basic-info-time {
      .basic-span {
        margin-bottom: 8px;
      }
    }
  }

  .step-info {
    border-bottom: 1px solid #DCDFE6;
    padding-bottom: 15px;
    margin: 10px 0;

    .steps {
      flex: 1;
      min-width: 1100px;
      margin: 30px;

      .planned {
        display: flex;
        flex-direction: column;
        position: absolute;
        top: -150px;
        left: 0;
      }

      .grey {
        color: #c7c6c6;
      }

      .orange {
        color: #efb336;
      }

      .blue {
        color: #1F75D5;
      }

      .top {
        top: -67px;
      }
    }

    .el-step__icon {
      display: inline-flex;
      width: 50px;
      height: 50px;
      border: none;
      background-color: #dfeefc;
    }

    .el-step {

      &__title,
      &__description,
      &__head {
        &.is-process {
          color: #1F75D5;
        }

        &.is-finish {
          color: #efb336;
        }

        &.is-wait {
          -webkit-filter: grayscale(100%);
          /* Chrome, Safari, Opera */
          filter: grayscale(100%);
        }
      }
    }

    .el-step.is-horizontal .el-step__line {
      height: 2px;
      top: 23px;
      left: 0;
      right: 0;
    }
  }

  .container-info {
    padding-bottom: 15px;
    margin: 10px 15px;
    flex-direction: column;

    &-main {
      display: flex;
      width: 100%;
      flex-direction: column;
    }

    &-list {
      ul {
        list-style: none;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        padding: 0;
        height: auto;

        li {
          width: 200px;
          text-align: center;
          border: 1px solid transparent;
          padding: 5px;
          border-radius: 12px;
          cursor: pointer;
          margin: 5px 15px;
          border: 0.5px solid #787878;
          background-color: white;

          &.isActive {
            color: black;
            text-align: center;
            background-color: #9bddff;
          }

          &:hover {
            background-color: #dfeefc;
          }

          span {
            line-height: 26px;
          }
        }
      }
    }

    &-details {
      display: flex;
    }

    &-left {
      flex: 1;
    }

    &-right {
      width: 400px;
    }

    &-title {
      font-size: 20px;
      text-align: left;

      p {
        margin: 0;
        width: fit-content;
      }
    }

    &-section {
      .title {
        font-size: 16px;
        padding: 0;
      }
    }
  }

  .instructions {
    text-align: right;
    flex: 1;

    span {
      display: block;
      margin-top: 5px;
    }
  }
}

.tab-data-tracking .step-info .el-step__description.is-wait {
  -webkit-filter: grayscale(0%);
  filter: grayscale(0%);
}

.hideWire {
  .el-dialog {
    margin-right: 50px !important;

    .el-dialog__header {
      border: none;
    }
  }

  .text {
    display: flex;
    align-items: center;
    font-size: 14px;

    i {
      font-size: 16px;
      font-size: 20px;
      margin-right: 5px;
      color: #E6A23F;
    }

    .see {
      color: rgb(31, 117, 213);
      cursor: pointer;
      font-size: 14px;
    }
  }

  .red {
    color: red;
    font-size: 14px;
  }
}
.air-flight-details::v-deep {
  .el-table__body-wrapper {
    height: auto!important;
  }
}
</style>
